function Contact() {
    return (
    <div className="Email_Me">
        <form method="POST" action="mailto:tobymorgan001@gmail.com" encType="text/plain">
            Fill the form below to send me an email:
            <br/><br/>
            <div className="row">
                <div className="column left">
                    <label htmlFor="clientName">Your name: </label>
                    <input type="text" id="clientName" name="My name"/>
                    <br/><br/>
                    <label htmlFor="clientBusiness">Your businesses name (optional): </label>
                    <input type="text" id="clientBusiness" name="My business"/>
                    <br/><br/>
                    <label htmlFor="clientEmail">Contact email: </label>
                    <input type="email" id="clientEmail" name="My email"/>
                    <br/><br/>
                    <label htmlFor="clientPhone">Contact phone (optional): </label>
                    <input type="tel" id="clientPhone" name="My phone"/>
                    <br/><br/><br/>
                    <label htmlFor="referees">Send referees</label>
                    <input type="checkbox" id="referees" name="Send referees"/>
                    <br/><br/>
                    <label htmlFor="transcript">Send transcript</label>
                    <input type="checkbox" id="transcript" name="Send transcript"/>
                    <br/><br/>
                </div>
                <div className="column right">
                    <label htmlFor="clientMessage" style={{verticalAlign: 'top'}}>Message:</label>
                    <textarea id="clientMessage" rows={8} cols={40} name="Message" style={{margin: '1em'}}/>
                </div>
                <br/><br/>
                <input type="submit" id="send" value="Send"/>
            </div>
            
        </form>
    </div>
    );
}

export default Contact;